import { colors } from './colors';
import { typography } from './typography';
import { spacing } from './spacing';
import { radii } from './radii';
import { shadows } from './shadows';
import { zIndex } from './zIndex';

export const theme = Object.freeze({
  colors,
  typography,
  spacing,
  radii,
  shadows,
  zIndex
});



// WEBPACK FOOTER //
// ./src/design-system/theme/index.js